import axios from "axios";
import { type Suggestion } from "../interfaces/commission";

export const fetchAccumulatorContactors = async (
    search: string
): Promise<Suggestion[]> => {
    const { data } = await axios.get(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/accumulator_contactor/list`,
        { 
            params: { search },
            withCredentials: true 
        }
    )

    return data.results.map((item: any) => ({
        id: item.id,
        name: item.name,
    }));
}